export default __webpack_public_path__ + "static/media/angle.997183a6.svg";